module.exports = __webpack_public_path__ + "img/bala.88ebc2eb.jpg";